module.exports = __webpack_public_path__ + "media/images/workshop_illustration_banner-a82ff9880430428b7e49081b17ee793e.jpg";